import type { ReactNode } from 'react';

type LogoCardProps = {
  children: ReactNode;
};

export function LogoCard({ children }: LogoCardProps) {
  return (
    <div className="flex min-h-[132px] items-center justify-center rounded-[10px] bg-[#f3f3f3] px-5 py-8 md:min-h-[160px] md:px-6">
      {children}
    </div>
  );
}
